$(document).on('turbolinks:load', () => {
  $('.b-faq > ul > li .label').on('click', ({ currentTarget }) => {
    $(currentTarget)
      .parent()
      .toggleClass('active');
  });
});
